<template>
  <v-card tile>
    <v-card-title>Nastavitve</v-card-title>
    <v-card-text
      ><v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item.tab">
          {{ item.tab }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.tab">
          <v-card flat>
            <v-card-text>
              <component :is="item.component"></component>
            </v-card-text>
          </v-card>
        </v-tab-item> </v-tabs-items
    ></v-card-text>
  </v-card>
</template>
<script>
  import EmployeeStatusVue from "@/components/Settings/EmployeeStatus.vue";
  import EmployeeWorkType from "@/components/Settings/EmployeeWorkType.vue";
  import Insurance from "@/components/Settings/Insurance.vue";
  import DocumentType from "@/components/Settings/DocumentType.vue";
  import MoneyType from "@/components/Settings/MoneyType.vue";
  export default {
    data: () => ({
      tab: null,
      items: [
        { tab: "Status zaposlenega", component: EmployeeStatusVue },
        { tab: "Tip dela zaposlenega", component: EmployeeWorkType },
        { tab: "Zavarovalnica", component: Insurance },
        { tab: "Tip dokumenta", component: DocumentType },
        { tab: "Tip transakcije", component: MoneyType },
      ],
    }),
    mounted() {},
    methods: {},
    computed: {},
    components: {},
  };
</script>
<style></style>
